import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useSelector from '../../../redux/useSelector';

import { hideMessage } from '../redux/message.actions';
import MessageCmp from '../components/message.component';

const MessageContainer: React.FC = () => {
  const dispatch = useDispatch();
  const feedMessage = useSelector(state => state.feedMessage);
  const { showMessage } = feedMessage;
  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 5000);
    }
  }, [showMessage, dispatch]);
  return (
    <MessageCmp
      code={feedMessage.code}
      type={feedMessage.type}
      message={feedMessage.message}
      showMessage={feedMessage.showMessage}
    />
  );
};

export default MessageContainer;
